import styled, { css } from "styled-components"

export const FooterContainer = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  margin: 12px auto 20px;
  background-color: #abaeb020;
  height: 45px;
  width: 95%;
  color: #0008;
  border-radius: 4px;
  div {
    font-size: 12px;
    line-height: 20px;
  }
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    form {
      margin-right: 10px;
    }
  }
`

export const FooterButton = styled.button<{ disabled: boolean }>`
  height: 20px;
  width: 20px;
  border: 1px solid var(--grey-border);
  border-radius: 4px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  transition: 0.3s ease;
  cursor: pointer;
  background-color: var(--white);
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.2;
      background-color: var(--grey-border);
    `};
`

export const FooterArrow = styled.div`
  height: 6px;
  width: 6px;
  border: solid var(--blue);
  border-width: 0 2px 2px 0;
  &.prev {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    margin-left: 2px;
  }
  &.next {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    margin-right: 2px;
  }
`
